import React from "react";
import Loadable from "../../react-loadable";

const WeaCron = Loadable({
  loader: () => import("./Cron"),
  loading: () => null,
  render: (obj, props, ref) => {
    if (obj) {
      return React.createElement(obj && obj.__esModule ? obj.default : obj, {
        ...props,
        ref
      });
    }
    return null;
  }
});

export default WeaCron;



// WEBPACK FOOTER //
// ./ecology9/wea-cron/index.js